<template lang="pug">
a.down-arrow( href='#' v-on='$listeners' )
  .arrow.arrow-1
  //- .arrow.arrow-2
  .arrow.arrow-3
  //- .arrow.arrow-4
</template>

<script lang="js">

export default {
  name: 'down-arrow',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
@import "~breakpoint-sass/stylesheets/breakpoint";
@import "@/scss/vars";

.down-arrow {
  display: block;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform-origin: 50% 50%;
  transform: translateX(-50%);
  height: 50px;
  width: 50px;
  z-index: 12;
  opacity: 0.5;
  // @include breakpoint( $max-phone-wh ) {
    //   height: 72px;
    //   width: 72px;
    //   bottom: -18px;
    // }
  &:hover {
    opacity: 1;
  }
  .arrow {
    opacity: 0;
    position: absolute;
    left: 20%;
    top: 55%;
    transform-origin: 50% 50%;
    transform: translate3d(-50%, -50%, 0);
  }
  .arrow-1 {
    animation: arrow-movement 3s ease-in-out infinite;
  }
  .arrow-2 {
    animation: arrow-movement 3s 0.75s ease-in-out infinite;
  }
  .arrow-3 {
    animation: arrow-movement 3s 1.5s ease-in-out infinite;
  }
  .arrow-4 {
    animation: arrow-movement 3s 2.25s ease-in-out infinite;
  }

  .arrow:before,
  .arrow:after {
    background: #fff;
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    @include breakpoint( $max-phone-wh ) {
      width: 20px;
    }
  }

  .arrow:before {
    transform: rotate(45deg) translateX(-21%);
    @include breakpoint( $max-phone-wh ) {
      transform: rotate(45deg) translateX(-17%);
    }
    transform-origin: top left;
    border-top-left-radius: 1.5px;
    border-bottom-left-radius: 1.5px;
  }

  .arrow:after {
    transform: rotate(-45deg) translateX(21%);
    @include breakpoint( $max-phone-wh ) {
      transform: rotate(-45deg) translateX(17%);
    }
    transform-origin: top right;
    border-top-right-radius: 1.5px;
    border-bottom-right-radius: 1.5px;
  }
}
// Animation
@keyframes arrow-movement {
  0% {
    opacity: 0;
    top: 0;
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.page.about, .page.contact {
  .down-arrow {
    display: none;
  }
}
</style>
